// Chips are filters only (CONTRACT "Controls"): 24 px, radius 4, outlined
// soft; pressed is tonal fill plus 600, never blue. Count in muted. CountChip
// is the tonal dot-plus-text chip of the top bar ("Sources: 1 of 6 routes").
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';
import { PresenceDot, type Presence } from './PresenceDot';
import './Chip.css';

export interface ChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  readonly pressed?: boolean;
  readonly count?: number | string;
  readonly icon?: ReactNode;
  readonly children: ReactNode;
}

export function Chip({ pressed = false, count, icon, className, children, type = 'button', ...rest }: ChipProps) {
  return (
    <button type={type} className={cx('chip', className)} aria-pressed={pressed} {...rest}>
      {icon ? <span className="chip-ic" aria-hidden="true">{icon}</span> : null}
      <span className="chip-lbl">{children}</span>
      {count !== undefined ? <span className="chip-n num">{count}</span> : null}
    </button>
  );
}

export interface CountChipProps {
  readonly presence?: Presence;
  readonly quiet?: boolean;
  readonly children: ReactNode;
  readonly className?: string;
  readonly title?: string;
}

export function CountChip({ presence, quiet = false, children, className, title }: CountChipProps) {
  return (
    <span className={cx('chip-count', quiet && 'chip-count-quiet', className)} title={title}>
      {presence ? <PresenceDot presence={presence} /> : null}
      <span className="chip-count-tx">{children}</span>
    </span>
  );
}
